import Icon from '@/components/snippets/icon/icon'
import { useAccountLayoutContext } from './AccountProfileContext'
import { useState } from 'preact/hooks'
import { parseFormData } from '../helpers/parseFormData'
import { ModalBodyWrapper } from './AccountModal'
import { getRemainingDaysOnAssignment } from '../helpers/getRemainingDates'
const PRODUCT_IMAGE = 'https://cdn.shopify.com/s/files/1/0690/5538/1801/files/4-501874.jpg?v=1720590706&width=960'

const AssignChildSelectInput = ({ shoeId, variantOmneoId, profileChildren }) => {
  return (
    <div>
      <select name={`${shoeId}_${variantOmneoId}`} className={'w-full rounded-md border-neutrals-medium-grey'}>
        <option value="-1">Assign child</option>
        {profileChildren.map((profile) => {
          const firstName = profile.first_name || profile.connector?.first_name || 'Child'
          const lastName = profile.last_name || profile.connector?.last_name || ''
          const id = profile.connectionId || profile.id

          return (
            <option key={id} value={id}>
              {firstName} {lastName !== 'Unknown' ? lastName : ''}
            </option>
          )
        })}
      </select>
    </div>
  )
}

const AssignChildBanner = ({ remainingDays }) => {
  return (
    <div className={'w-full rounded-md bg-secondary-paleblue bg-opacity-[0.24]'}>
      <div className={'flex flex-row items-center gap-2 p-2'}>
        <Icon id="gift" />
        <p className={'paragraph-xs'}>Earn $2 reward for assigning - Expires in {remainingDays} days</p>
      </div>
    </div>
  )
}

/**
 * @param {Order} props
 */
const AccountAssignShoe = ({ shoe, handleAssignShoe, profileChildren }) => {
  const daysSincePurchase = getRemainingDaysOnAssignment(shoe?.created_at)

  const image = shoe?.product_images?.[0]?.url ?? PRODUCT_IMAGE
  const size = shoe?.product_variant?.meta?.shopify?.option1 || null

  return (
    <div className={'border-medium-grey mb-6 flex flex-row gap-4 border-b pb-6 last:mb-0 last:border-none last:pb-0'}>
      <div className={'aspect-1 h-32 w-32'}>
        <img className={'h-full w-full object-cover object-bottom'} src={image} />
      </div>
      <div className={'flex w-full flex-grow flex-col gap-4'}>
        <div className={'flex flex-row justify-between'}>
          <div className={'flex flex-col gap-2'}>
            <p className={'paragraph-sm font-bold'}>{shoe?.product?.brand}</p>
            <p className={'paragraph-md '}>{shoe?.product?.title}</p>
            {!!size && (
              <div className={'flex flex-col'}>
                <p className={'paragraph-sm text-neutrals-secondary-grey'}>Size: {size}</p>
              </div>
            )}
          </div>
          <div></div>
        </div>
        <div className={'space-y-2'}>
          <AssignChildSelectInput
            shoeId={shoe.id}
            variantOmneoId={shoe.product_variant_id}
            profileChildren={profileChildren}
          />
          {daysSincePurchase > 0 && <AssignChildBanner remainingDays={daysSincePurchase} />}
        </div>
      </div>
    </div>
  )
}

export const FormAssignShoes = ({ profileChildren, shoes, handleToggle, handleRefetch }) => {
  const { omneoClient } = useAccountLayoutContext()
  const [isLoading, setIsLoading] = useState()

  const handleAssignShoe = async (shoeId, variantOmneoId, childId) => {
    try {
      await omneoClient.assignItemToChild(shoeId, variantOmneoId, childId)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <ModalBodyWrapper
      config={{
        submitButtonText: 'Save',
        handleToggle,
        isLoading,
        submitCallback: async (e) => {
          e.preventDefault()
          const data = new FormData(e.currentTarget)
          const lines = Object.entries(
            parseFormData(
              data,
              shoes?.map((shoe) => `${shoe.id}_${shoe.product_variant_id}`)
            ) || {}
          )
            .map(([key, value]) => {
              const [shoeId, variantOmneoId] = key.split('_')
              return { shoeId, variantOmneoId, childId: value }
            })
            .filter((line) => line.childId !== '-1')

          if (lines.length === 0) return

          setIsLoading(true)
          // Group lines by Child ID to batch requests
          const groupedLines = lines.reduce((acc, line) => {
            if (!acc[line.childId]) {
              acc[line.childId] = []
            }
            acc[line.childId].push({ shoeId: line.shoeId, variantOmneoId: line.variantOmneoId })
            return acc
          }, {})
          for (const [childId, lines] of Object.entries(groupedLines)) {
            await omneoClient.assignItemsToChild(lines.map((line) => line.shoeId), lines.map((line) => line.variantOmneoId), childId, true)
          }
          omneoClient.triggerRewardsRefresh()
          setIsLoading(false)
          handleToggle()
          handleRefetch()
        }
      }}
    >
      <div className={'p-2'}>
        {shoes?.map((shoe) => {
          return <AccountAssignShoe shoe={shoe} handleAssignShoe={handleAssignShoe} profileChildren={profileChildren} />
        })}
      </div>
    </ModalBodyWrapper>
  )
}
